<template>
  <div class="collapsible-main">
    <div :class="['title-container', { 'disabled': isDisabled }]" @click="isOpen = !isOpen">
      <img :class="{ 'isOpen': isOpen && !isDisabled }" src="../assets/collapsible/dropdown.png" alt="">
      <div class="title">{{ title }}</div>
      <div class="button-section">
        <img v-if="showEdit" src="@/assets/edit.png" alt="Edit" @click="editClicked">
        <img v-if="showDelete" src="@/assets/delete.png" alt="Delete" @click="deleteClicked">
      </div>
    </div>
    <div v-show="isOpen && !isDisabled" class="collapsible-content">
      <slot></slot>
    </div>
    <div class="disabled-overlay" v-if="isDisabled"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, withDefaults, defineEmits } from 'vue';
import { CollapsibleSectionEvents, CollapsibleSectionProps } from './componentModel/CollapsibleModel';

const props = withDefaults(defineProps<CollapsibleSectionProps>(), {
  isDisabled: false,
  showDelete: false,
  showEdit: false
});

const emit = defineEmits<CollapsibleSectionEvents>();

// #region Data
const isOpen = ref(true);
// #endregion Data

// #region Methods
const deleteClicked = (e: Event) => {
  // To disabled closing of the section
  e.stopPropagation();
  // Emit the click with the ID
  if (!props.id) {
    console.warn('Delete is enabled, but id is not set for the collapsible section.')
  } else {
    emit('deleteClicked', props.id);
  }
}
const editClicked = (e: Event) => {
  // To disabled closing of the section
  e.stopPropagation();
  // Emit the click with the ID
  if (!props.id) {
    console.warn('Edit is enabled, but id is not set for the collapsible section.')
  } else {
    emit('editClicked', props.id);
  }
}
// #endregion Methods
</script>

<style scoped>
.collapsible-main {
  border: 1px solid gray;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
}
.title-container {
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
  
  > img {
    cursor: pointer;
    height: 20px;
    transition: 0.3s;

    &.isOpen {
      transform: rotate(180deg);
    }
  }

  > .title {
    width: 100%;
  }

  &.disabled {
    opacity: 0.5;
  }
}
.disabled-overlay {
  background-color: rgba(128,128,128,0.3);
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 9;
}
.collapsible-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.button-section {
  display: flex;
  gap: 10px;
  align-items: center;

  > img {
    cursor: pointer;
    height: 20px;
    transition: 0.3s;

    &.isOpen {
      transform: rotate(180deg);
    }
  }
}
</style>